import {EntityData} from "@fedelta-pos/data-client";
import {MenuItemSelection} from "../menu/menu-events";
import {AddressData} from "../customer-info/address.data";
import {StoreData} from "../store/store-search.model";
import {OrderType} from "../order/order";

// noinspection JSUnusedGlobalSymbols
export enum OrderingContextIntention {
    NONE,
    ORDER,
    SELECT_STORE,
    SELECT_ORDER_TYPE,
    CHANGE_FULFILMENT_DETAILS, // Changing address or table
    VIEW_STORES,
    VIEW_CURRENT_STORE
}

export class TableSelection {
    lookupCode?: string;
    tableNumber?: string;
    storeGroup?: string;
    storeIds?: number[];
    exclusiveStores?: boolean;
    tableOnlyMode?: boolean;
    pickupOnlyMode?: boolean;
    deliveryOnlyMode?: boolean;
    localTable?: boolean;
}

export class DeliveryDetails {
    address: AddressData;

    constructor(street?: string, city?: string, state?: string, postCode?: string,
                public orderMobilePhone?: string, public deliveryInstructions?: string,
                public saveAddressForMember?: boolean, public latitude?: number, public longitude?: number) {
        this.address = <AddressData>EntityData.create(AddressData);
        this.address.street = street;
        this.address.city = city;
        this.address.state = state;
        this.address.postCode = postCode;
    }
}

export class OrderingContext {
    private _intention: OrderingContextIntention;
    private _selectedStore: StoreData;
    private _selectedTable: TableSelection;
    private _selectedOrderType: OrderType;
    private _selectedMenuItem: MenuItemSelection;
    private _selectedDeliveryDetails: DeliveryDetails;
    private _defaultOrderType: OrderType;

    /**
     * Immutable properties - set using cloning methods below.
     */
    get intention(): OrderingContextIntention {
        return this._intention;
    }

    get selectedStore(): StoreData {
        return this._selectedStore;
    }

    get selectedTable(): TableSelection {
        return this._selectedTable;
    }

    get selectedOrderType(): OrderType {
        return this._selectedOrderType;
    }

    get selectedMenuItem(): MenuItemSelection {
        return this._selectedMenuItem;
    }

    get selectedDeliveryDetails(): DeliveryDetails {
        return this._selectedDeliveryDetails;
    }

    get defaultOrderType(): OrderType {
        return this._defaultOrderType;
    }

    /**
     * Cloning methods
     * The objective is that as additional context information is collected, it does not change the original context,
     * so state is preserved when the user backs out of an action.
     */

    public withIntention(intention: OrderingContextIntention): OrderingContext {
        const clone: OrderingContext = this.clone();
        clone._intention = intention;
        return clone;
    }

    public withSelectedStore(selectedStore: StoreData): OrderingContext {
        const clone: OrderingContext = this.clone();
        clone._selectedStore = selectedStore;
        return clone;
    }

    public withSelectedTable(selectedTable: TableSelection, changeIfSet: boolean = true): OrderingContext {
        if (!changeIfSet && this._selectedTable) {
            return this;
        }
        const clone: OrderingContext = this.clone();
        clone._selectedTable = selectedTable;
        return clone;
    }

    public withSelectedOrderType(selectedOrderType: OrderType): OrderingContext {
        const clone: OrderingContext = this.clone();
        clone._selectedOrderType = selectedOrderType;
        return clone;
    }

    public withSelectedMenuItem(selectedMenuItem: MenuItemSelection): OrderingContext {
        const clone: OrderingContext = this.clone();
        clone._selectedMenuItem = selectedMenuItem;
        return clone;
    }

    public withSelectedDeliveryDetails(selectedDeliveryDetails: DeliveryDetails): OrderingContext {
        const clone: OrderingContext = this.clone();
        clone._selectedDeliveryDetails = selectedDeliveryDetails;
        return clone;
    }

    public withDefaultOrderType(defaultOrderType: OrderType): OrderingContext {
        const clone: OrderingContext = this.clone();
        clone._defaultOrderType = defaultOrderType;
        return clone;
    }

    private clone(): OrderingContext {
        const clone: OrderingContext = Object.assign(new OrderingContext(), this);
        clone._selectedTable = this._selectedTable ? Object.assign(new TableSelection(), this._selectedTable) : undefined;
        return clone;
    }
}



// WEBPACK FOOTER //
// ./src/app/ordering-context/ordering-context.ts